import { render, staticRenderFns } from "./SplashPage.vue?vue&type=template&id=0f708f19&scoped=true&"
import script from "./SplashPage.vue?vue&type=script&lang=js&"
export * from "./SplashPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f708f19",
  null
  
)

export default component.exports